import React, { FunctionComponent } from 'react';
import { SendOutBatchTemplate } from '../../MBS/models';
import MBSTemplate from '../../MBS/MBSCreateNew/MBSTemplate';
import Input from "@murphy-frontend/web-core/components/Input";
import Textarea from "@murphy-frontend/web-core/components/TextArea";
import { CustomCheckbox } from '../../../common/components/MurphyCheckbox';

interface AlertTemplateBasicInfoProps {
  templates: SendOutBatchTemplate[],
  onSelectTemplate: (templateId: number) => void,
  selectedId: string,
  messageTemplateIsFlashing: boolean,
  name: string,
  description: string,
  handleNameChange: any,
  handleDescriptionChange: any,
  translations?: Record<string, string>,
  onEnableEventflow: () => boolean,
  EnableEventflowIsChecked: boolean,
  includeSenderEmail: boolean,
  includeSenderUserName: boolean,
  onChangeIncludeSenderEmail: (checked: boolean) => void,
  onChangeIncludeSenderUserName: (checked: boolean) => void
}

const styles = {
  row: {
    display: 'flex',
    width: '80rem'
  },
  input: {
    borderWidth: 1,
    borderColor: '#EBEBEB',
    borderStyle: 'solid',
    borderRadius: 5,
    width: '60rem'
  },
  label: {
    width: '10rem',
    color: '#626262'
  },
  required: {
    width: '10rem',
    color: '#626262',
    fontSize: 10,
    fontStyle: 'italic'
  }
}

const AlertTemplateBasicInfo: FunctionComponent<AlertTemplateBasicInfoProps> = ({
  templates,
  onSelectTemplate,
  selectedId,
  name,
  description,
  messageTemplateIsFlashing,
  translations,
  handleNameChange,
  handleDescriptionChange,
  onEnableEventflow,
  EnableEventflowIsChecked,
  includeSenderEmail,
  includeSenderUserName,
  onChangeIncludeSenderEmail,
  onChangeIncludeSenderUserName
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 20, paddingRight: 20, marginTop: 20 }}>
      <div style={styles.row}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={styles.label}>{translations.name}</span>
          <span style={styles.required}>{translations.required || "required"}</span>
        </div>

        <Input
          val={name}
          isRequired
          style={styles.input}
          handleChange={handleNameChange}
        // errorMessage={messageBodyError}
        />
      </div>

      <div style={styles.row}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={styles.label}>{translations["class-lang-modal-description"] || "Description"}</span>
          <span style={styles.required}>{translations.required || "required"}</span>
        </div>
        <Textarea
          title={""}
          val={description}
          style={styles.input}
          isRequired
          handleChange={handleDescriptionChange}
          // errorMessage={messageBodyError}
          rows={3}
          cols={1}
          placeholder={translations.tmpMaxchars100 || "Max 100 characters..."}
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label style={{ fontSize: '18px', marginBottom: 20, color: 'grey', marginTop: 20 }}>
          {translations.selectAlertType || "Select alert type"}
        </label>
        <label style={{ color: 'grey', marginBottom: 10 }}>
          {translations.default || "Default"}
        </label>
      </div>

      {/* Default Templates */}
      <ul className="template-selector-wrapper">
        {templates.map((template, index) => (
          <li key={`default-${template.id}`}>
            <MBSTemplate
              id={template.id}
              title={template.title}
              description={template.description}
              flashing={messageTemplateIsFlashing && index === 0}
              replyRequired={template.replyRequired}
              onSelectTemplate={onSelectTemplate}
              selected={selectedId === `default-${template.id}`}
              templateType="default"
            />
          </li>
        ))}
      </ul>

      <div className='flex-row-container vertical-aligner left-aligner margin-top-20'>
        <CustomCheckbox
          onChange={onEnableEventflow}
          checked={EnableEventflowIsChecked}
          checkedColor="#00A098"
          unCheckedColor="#7F7F7F"
        />
        <label style={{ color: 'grey', width: '30rem', fontSize: 14 }}>
          {translations.tmpEnableEventflow || "Make template available for eventflow"}
        </label>
      </div>

      {EnableEventflowIsChecked && (
        <div>
          <div className='flex-row-container vertical-aligner left-aligner margin-top-10'>
            <CustomCheckbox
              onChange={(checked: boolean) => onChangeIncludeSenderEmail(checked)}
              checked={includeSenderEmail}
              checkedColor="#00A098"
              unCheckedColor="#7F7F7F"
            />
            <label style={{ color: 'grey', width: '30rem', fontSize: 14 }}>
              {translations.tmpIncludeSenderEmail || "Include sender email in body"}
            </label>
          </div>

          <div className='flex-row-container vertical-aligner left-aligner margin-top-10'>
            <CustomCheckbox
              onChange={(checked: boolean) => onChangeIncludeSenderUserName(checked)}
              checked={includeSenderUserName}
              checkedColor="#00A098"
              unCheckedColor="#7F7F7F"
            />
            <label style={{ color: 'grey', width: '30rem', fontSize: 14 }}>
              {translations.tmpIncludeSenderUserName || "Include sender username in body"}
            </label>
          </div>
        </div>
      )}

      <br></br>

    </div>
  );
};

export default AlertTemplateBasicInfo;